import React from "react";
import Otp from 'react-otp-input';
import "./otp_input.ui.scss";

interface IOtpProps {
    value: string;
    onChange: any;
    numInputs: number;
    isAutoFocus?: boolean;
    placeholder?: string;
}

// The boxes are plain inputs rendered here (not the shared Input): react-otp-input hands each box a `ref` it
// uses to move focus, and a function component that does not forward it leaves every box unfocusable.
const OtpInput = (props: IOtpProps) => {
    return (
        <div className="otp_input">
            <Otp
                containerStyle="otp_input_container"
                value={props.value}
                onChange={(value: string) => props.onChange(value)}
                numInputs={props.numInputs}
                renderInput={({ ref, style, className, ...inputProps }: any) => (
                    <input
                        {...inputProps}
                        ref={ref}
                        className={`otp_input_box ${inputProps.value ? "otp_input_box_filled" : ""}`}
                        inputMode="numeric"
                        autoComplete="one-time-code"
                    />
                )}
                shouldAutoFocus={props.isAutoFocus}
                placeholder={props.placeholder}
            />
        </div>
    )
}

export default OtpInput;
